import {FC, useEffect} from 'react'
import {useLocation} from 'react-router'
import clsx from 'clsx'
import {useLayout} from '../core'
import {DrawerComponent} from '../../assets/ts/components'
import {WithChildren} from '../../helpers'
import { Tooltip as ReactTooltip } from 'react-tooltip'
import {PageBreadcrumb} from './PageBreadcrumb'

const Content: FC<WithChildren> = ({children}) => {
  const {classes} = useLayout()
  const location = useLocation()
  useEffect(() => {
    DrawerComponent.hideAll()
  }, [location])

  return (
    <div id='kt_content_container test_card' className={clsx(classes.contentContainer.join(' '))}>
      <PageBreadcrumb />
      {children}
      <ReactTooltip id="tooltip-container" />
    </div>
  )
}

export {Content}
